import { render, staticRenderFns } from "./ChooseShippingOption.vue?vue&type=template&id=04cbbc06"
import script from "./ChooseShippingOption.vue?vue&type=script&lang=js"
export * from "./ChooseShippingOption.vue?vue&type=script&lang=js"
import style0 from "./ChooseShippingOption.vue?vue&type=style&index=0&id=04cbbc06&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports